import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import { useLeadDropReasons } from '../../hooks/useLeadDropReasons';
import { useMarkLeadAsDead } from '../../hooks/useLeads';

interface DeadLeadDialogProps {
  open: boolean;
  onClose: () => void;
  leadId: string;
  onLeadMarkedAsDead?: () => void;
}

const DeadLeadDialog: React.FC<DeadLeadDialogProps> = ({ open, onClose, leadId, onLeadMarkedAsDead }) => {
  const [selectedDropReason, setSelectedDropReason] = useState('');
  const markAsDead = useMarkLeadAsDead();
  const { data: dropReasons, isLoading: isLoadingDropReasons } = useLeadDropReasons();

  const handleMarkAsDead = async () => {
    if (!selectedDropReason) return;
    
    try {
      await markAsDead.mutateAsync({
        leadId,
        dropReason: selectedDropReason
      });
      if (onLeadMarkedAsDead) {
        onLeadMarkedAsDead();
      }
      onClose();
      setSelectedDropReason('');
    } catch (error) {
      
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={() => {
        onClose();
        setSelectedDropReason('');
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Mark Lead as Dead</DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <FormControl fullWidth required error={!selectedDropReason} sx={{ mt: 2 }}>
          <InputLabel id="drop-reason-label">Reason</InputLabel>
          <Select
            labelId="drop-reason-label"
            value={selectedDropReason}
            label="Reason"
            onChange={(e: SelectChangeEvent) => setSelectedDropReason(e.target.value)}
          >
            {dropReasons?.filter(reason => reason.active).map((reason) => (
              <MenuItem key={reason._id} value={reason._id}>
                {reason.value}
              </MenuItem>
            ))}
          </Select>
          {!selectedDropReason && (
            <FormHelperText>Please select a reason</FormHelperText>
          )}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => {
            onClose();
            setSelectedDropReason('');
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleMarkAsDead} 
          color="error" 
          disabled={!selectedDropReason}
          autoFocus
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeadLeadDialog;
